<template>
  <div>
    <div class="p-t-none">
      <v-flex class="tituloBox">
        <div class="bg-red barraTitulo"></div>
        <h1 class="text-default font-size-14">
          <strong>Sócios</strong>
        </h1>
      </v-flex>
    </div>
    <div class="clear"></div>
    <v-data-table
      :headers="dadosBasicosSocioDirigente.concat(localcabecalhoSocios)"
      :items="sociosLista"
      :loading="loading"
      :hide-actions="true"
      
    >
      <template slot="items" slot-scope="props">
        <td >{{ props.item.nome }}</td>
        <td >
          <input
            v-if="props.item.flagEstrangeiro == 0"
            v-mask="(props.item.tipoHabilitador =='J') ? maskCnpj : maskCpf"
            readonly
            :value="props.item.cpfCnpj"
          >
          <input
            v-if="props.item.flagEstrangeiro == 1"
            readonly
            :value="props.item.cpfCnpj"
          >
        </td>
        <td >{{ props.item.flagEstrangeiro == "0" ? "Sim" : "Não" }}</td>
        <td>{{ props.item.percentual }}</td>
        <td v-if="$verificaPerfilCadastrador() || $verificaPerfilHabilitador()" class="text-xs-center naoImprimir">
       
          <a v-if="props.item.numDocumentoSEI" v-bind:href="props.item.arquivoUpload" target="_blank">
            <v-icon color="blue">attach_file</v-icon>
          </a>
          <v-icon v-else color="grey">attach_file</v-icon>         
        </td> 
      </template>
    </v-data-table>
  </div>
</template>


<script>
import util from "../../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
export default {
  name: "socios-crud",
  mixins: [util],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object
  },
  computed: {//Campos computados
    sociosLista: function() {
      //retorna a lista de socios
      if(!this.model.fornecedoresHabilitacaoJuridica) return [];
      let lista = this.model.fornecedoresHabilitacaoJuridica.filter(
        item => item.tipoCadastro === "S"
      );
      if (lista.length) return lista;
      else return [];
    }
  },
  mounted() {
    this.localcabecalhoSocios = this.cabecalhoSocios; // Inicializa com os headers do mixin
    if (this.$verificaPerfilCadastrador() || this.$verificaPerfilHabilitador()) {
      this.localcabecalhoSocios.push({
        text: this.$t("label.anexo"),
        align: "center",
        sortable: false,
        class: "naoImprimir",
      });
    }
  },
  created() /*Metodo de start do componente*/{},
  data() {//Declaracao de variaveis
    return {
      localcabecalhoSocios: [],
      totalDesserts: 0,
      loading: false,
    };
  }
};
</script>